import React from 'react';
import { revenueData } from '../../data/mockData';
import ScoreIndicator from '../common/ScoreIndicator';

const ScoringView = ({ state }) => {
  const { calculateScore } = state;

  return (
    <div style={{ padding: '32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 24, fontWeight: '600', color: '#f3f4f6' }}>Opportunity Scoring</h2>
          <p style={{ margin: '8px 0 0', color: '#9ca3af', fontSize: 14 }}>
            Revenue modeling {'\u2022'} Audience match {'\u2022'} Final score calculation
          </p>
        </div>
        <button
          onClick={calculateScore}
          style={{
            backgroundColor: '#6366f1',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: 8,
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: 14
          }}
        >
          Calculate Final Score {'\u2192'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 24, border: '1px solid #2d2d44' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Revenue Projection</h3>
          <div style={{ display: 'grid', gap: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 16, backgroundColor: '#252540', borderRadius: 8 }}>
              <span style={{ fontSize: 14, color: '#9ca3af' }}>Projected RPM</span>
              <span style={{ fontSize: 24, fontWeight: '700', color: '#10b981' }}>{revenueData.projectedRPM}</span>
            </div>
            <div>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8, textTransform: 'uppercase' }}>Historical Benchmarks</div>
              {Object.entries(revenueData.historicalPerformance).map(([key, value]) => (
                <div key={key} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                  <span style={{ fontSize: 13, color: '#9ca3af', textTransform: 'capitalize' }}>{key.replace(/([A-Z])/g, ' $1')}</span>
                  <span style={{ fontSize: 13, color: '#f3f4f6' }}>{value}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 8 }}>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8, textTransform: 'uppercase' }}>Commerce Potential</div>
              <div style={{ fontSize: 14, color: '#f3f4f6' }}>{revenueData.commercePotential} - {revenueData.affiliateOpportunity}</div>
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 24, border: '1px solid #2d2d44' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Audience Match</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 24 }}>
            <ScoreIndicator score={revenueData.audienceMatch.score} size="large" />
            <div>
              <div style={{ fontSize: 14, color: '#f3f4f6', fontWeight: '500' }}>Overall Match Score</div>
              <div style={{ fontSize: 13, color: '#9ca3af' }}>Based on existing audience data</div>
            </div>
          </div>
          <div style={{ display: 'grid', gap: 12 }}>
            {Object.entries(revenueData.audienceMatch.breakdown).map(([key, value]) => (
              <div key={key}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 13, color: '#9ca3af', textTransform: 'capitalize' }}>{key.replace(/([A-Z])/g, ' $1')}</span>
                  <span style={{ fontSize: 13, color: '#f3f4f6' }}>{value}</span>
                </div>
                <div style={{ height: 6, backgroundColor: '#374151', borderRadius: 3 }}>
                  <div style={{ height: '100%', width: `${value}%`, backgroundColor: '#6366f1', borderRadius: 3 }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoringView;
